import React from 'react';
import './Process.css';

interface ProcessStep {
  id: number;
  title: string;
  description: string;
  icon: React.ReactNode;
}

// Inline SVG icons — no external dependency
const IconSourcing = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2a9 9 0 0 1 9 9c0 5-9 13-9 13S3 16 3 11a9 9 0 0 1 9-9z" />
    <circle cx="12" cy="11" r="3" />
  </svg>
);

const IconQualityCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
    <polyline points="11 8 11 11 13 13" />
  </svg>
);

const IconProcessing = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18" />
  </svg>
);

const IconPackaging = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="21 8 21 21 3 21 3 8" />
    <rect x="1" y="3" width="22" height="5" />
    <line x1="10" y1="12" x2="14" y2="12" />
  </svg>
);

const IconExport = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 17l4-8 4 5 3-3 4 6" />
    <path d="M2 20h20" />
    <path d="M18 8l3-3-3-3" />
    <path d="M21 5H13" />
  </svg>
);

const processSteps: ProcessStep[] = [
  {
    id: 1,
    title: 'Sourcing',
    description: 'We carefully select herbs from certified organic farms and trusted suppliers across India',
    icon: <IconSourcing />,
  },
  {
    id: 2,
    title: 'Quality Check',
    description: 'Rigorous testing in our state-of-the-art laboratory ensures the highest quality standards',
    icon: <IconQualityCheck />,
  },
  {
    id: 3,
    title: 'Processing',
    description: 'Products are processed in our GMP certified facility following traditional methods',
    icon: <IconProcessing />,
  },
  {
    id: 4,
    title: 'Packaging',
    description: 'Eco-friendly packaging that maintains product integrity during international shipping',
    icon: <IconPackaging />,
  },
  {
    id: 5,
    title: 'Export',
    description: 'Efficient logistics and full documentation support for smooth international delivery',
    icon: <IconExport />,
  },
];

const Process: React.FC = () => {
  return (
    <section className="process" id="process">
      <div className="process-container">
        <h2>Our Export Process</h2>
        <p className="process-sub">
          From farm to your facility — every step is controlled, certified, and transparent.
        </p>
        <div className="process-steps">
          {processSteps.map((step) => (
            <div key={step.id} className="process-step">
              <div className="step-number">{String(step.id).padStart(2, '0')}</div>
              <div className="step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
